import { toDateKey, formatTimeOnly, normalizeDateTimeInput } from './dateTimeUtils';

const LOCALE = 'en-PH';
const TZ = 'Asia/Manila';

const dateOnlyFormatter = new Intl.DateTimeFormat(LOCALE, {
  timeZone: TZ,
  year: 'numeric',
  month: 'short',
  day: '2-digit',
});

const isDateOnlyString = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value);

const toManilaDateObject = (value) => {
  const dateKey = toDateKey(value);
  if (!dateKey) return null;
  const d = new Date(`${dateKey}T00:00:00+08:00`);
  return Number.isNaN(d.getTime()) ? null : d;
};

const hasTimeComponent = (value) => {
  if (isDateOnlyString(value)) return false;
  const d = new Date(normalizeDateTimeInput(value));
  if (Number.isNaN(d.getTime())) return false;
  const parts = new Intl.DateTimeFormat(LOCALE, {
    timeZone: TZ,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(d);
  const h = Number(parts.find((p) => p.type === 'hour')?.value || 0);
  const m = Number(parts.find((p) => p.type === 'minute')?.value || 0);
  const s = Number(parts.find((p) => p.type === 'second')?.value || 0);
  return h !== 0 || m !== 0 || s !== 0;
};

export function formatDatePH(value) {
  if (!value) return '';
  const raw = String(value).trim();
  if (!raw) return '';
  const d = isDateOnlyString(raw) ? toManilaDateObject(raw) : new Date(normalizeDateTimeInput(raw));
  if (!d || Number.isNaN(d.getTime())) return raw;
  return dateOnlyFormatter.format(d);
}

export function formatDateTimePH(value) {
  if (!value) return '';
  const raw = String(value).trim();
  if (!raw) return '';
  const d = new Date(normalizeDateTimeInput(raw));
  if (Number.isNaN(d.getTime())) return raw;
  return `${dateOnlyFormatter.format(d)} · ${formatTimeOnly(d)}`;
}

export function formatInboxDate(value) {
  if (!value) return '';
  const raw = String(value).trim();
  if (!raw) return '';
  if (hasTimeComponent(raw)) return formatDateTimePH(raw);
  return formatDatePH(raw);
}

export function formatMessageDates(text) {
  if (!text) return '';
  const raw = String(text);
  const isoDateTime = /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?\b/g;
  const isoDate = /\b\d{4}-\d{2}-\d{2}\b/g;
  const jsDateString = /\b(?:[A-Z][a-z]{2} )?[A-Z][a-z]{2} \d{1,2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4} \([^)]+\)\b/g;
  const replacedJsDate = raw.replace(jsDateString, (m) => formatDateTimePH(m));
  const replacedDateTime = replacedJsDate.replace(isoDateTime, (m) => formatDateTimePH(m));
  return replacedDateTime.replace(isoDate, (m) => formatDatePH(m));
}
